// src/pages/personal/platforms/MessengerPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import FacebookSection from './FacebookSection/FacebookSection';

const MessengerPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <FacebookSection />
    </AdaptiveLayout>
  );
};

export default MessengerPage;